import { MDBListGroup, MDBListGroupItem } from "mdb-react-ui-kit";

export const renderListItems = (items, renderItem) => {
  return items?.map((item, index) => (
    <MDBListGroup flush key={index}>
      {renderItem(item)}
    </MDBListGroup>
  ));
};

export const renderClearSkiesItem = (item) => (
  <MDBListGroupItem>
    <div>
      <strong>Alarm:</strong> {item?.value}
    </div>
  </MDBListGroupItem>
);
